import React from 'react';

const toHumanReadableSize = (bytes) => {
  let factor = 1;
  let unit = 'B';

  if (bytes > 1073741824) {
    factor = 1073741824;
    unit = 'GB';
  } else if (bytes > 1048576) {
    factor = 1048576;
    unit = 'MB';
  } else if (bytes > 1024) {
    factor = 1024;
    unit = 'KB';
  }

  return {
    size: (bytes / factor).toFixed(2),
    unit: unit
  };
};

class FileSize extends React.Component {
  render() {
    const humanReadable = toHumanReadableSize(this.props.bytes);
    return (
      <span>{humanReadable.size}&nbsp;{humanReadable.unit}</span>
    );
  }
}

FileSize.defaultProps = {
  bytes: 0
};

export default FileSize;
